"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrelationIdVO = void 0;
const crypto_1 = require("crypto");
const ValueObject_1 = require("../base/ValueObject");
class CorrelationIdVO extends ValueObject_1.ValueObject {
    constructor(value) {
        super(value);
    }
    static fromRequest(req) {
        const raw = req.headers?.['x-correlation-id'];
        const id = Array.isArray(raw) ? raw[0] : raw;
        return id ? new CorrelationIdVO(id) : undefined;
    }
    static fromString(value) {
        return new CorrelationIdVO(value);
    }
    static generate() {
        return new CorrelationIdVO((0, crypto_1.randomUUID)());
    }
    toShortForm() {
        return this.value.substring(0, 8);
    }
    validate() {
        if (!this.value?.trim())
            throw new Error('CorrelationId cannot be empty');
        if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(this.value)) {
            throw new Error('CorrelationId must be a valid UUID v4 format');
        }
    }
}
exports.CorrelationIdVO = CorrelationIdVO;
